import React, { useCallback } from "react";
import * as Styled from "../../styles";
import BasicInfos from "../BasicInfos";
import Credentials from "../Credentials";
import CreditCardBrands from "../CreditCardBrands";
import TabsNavigation from "../TabsNavigation";
import {
  useTabNavigationContext,
  useProviderFormContext,
} from "../../Context/ValidationContext";

interface TabContentRendererProps {
  handleStatusChange: (isActive: boolean) => void | Promise<void>;
}

function TabContentRenderer({ handleStatusChange }: TabContentRendererProps) {
  const {
    currentTab,
    previousTab,
    isAnimating,
    getAnimationDirection,
    tabErrors,
    setCurrentTab,
    handleChangeTab,
    showCredentialsTab,
    showBrandsTab,
  } = useTabNavigationContext();

  const { mode } = useProviderFormContext();

  const renderTabContent = useCallback(() => {
    const animationDirection = getAnimationDirection(currentTab, previousTab);

    return (
      <Styled.TabContentContainer>
        <Styled.TabContent
          isActive={currentTab === 1}
          animationDirection={animationDirection}
          isAnimating={isAnimating}
        >
          <BasicInfos
            onStatusChange={handleStatusChange}
            isEditMode={mode === "EDIT"}
          />
        </Styled.TabContent>

        {showCredentialsTab && (
          <Styled.TabContent
            isActive={currentTab === 2}
            animationDirection={animationDirection}
            isAnimating={isAnimating}
          >
            <Credentials />
          </Styled.TabContent>
        )}

        {showBrandsTab && (
          <Styled.TabContent
            isActive={currentTab === 3}
            animationDirection={animationDirection}
            isAnimating={isAnimating}
          >
            <CreditCardBrands />
          </Styled.TabContent>
        )}
      </Styled.TabContentContainer>
    );
  }, [
    getAnimationDirection,
    currentTab,
    previousTab,
    isAnimating,
    handleStatusChange,
    mode,
    showCredentialsTab,
    showBrandsTab,
  ]);

  return (
    <>
      <TabsNavigation
        currentTab={currentTab}
        onTabChange={handleChangeTab}
        onTabClick={setCurrentTab}
        errors={tabErrors}
        showCredentialsTab={showCredentialsTab}
        showBrandsTab={showBrandsTab}
      />
      {renderTabContent()}
    </>
  );
}

export default TabContentRenderer;
